import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-md navbar-transparent" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "collapse navbar-collapse" }
const _hoisted_4 = { class: "navbar-nav" }

import NavApp from "./NavApp.vue";
import { navigationConfig } from "@/shared/config";
import { useAuthStore } from "@/auth/store";
import { userShouldSeeApp } from "@/shared/services/navigation";

export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const authStore = useAuthStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "brand"),
      (_unref(authStore).isAuthenticated)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigationConfig), (app) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: app.title
                  }, [
                    (_unref(userShouldSeeApp)(app))
                      ? (_openBlock(), _createBlock(NavApp, {
                          key: 0,
                          icon: app.icon,
                          title: app.title,
                          items: app.items
                        }, null, 8, ["icon", "title", "items"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _renderSlot(_ctx.$slots, "right")
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})